var _Circle, _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgIconClockSmall = function SvgIconClockSmall(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 12"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 6,
    cy: 6,
    r: 5.4,
    stroke: "#FF9",
    strokeWidth: 1.2
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FF9",
    d: "M5.4 2.6h1.2v3.6H5.4z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FF9",
    d: "M6 5.6h2.8v1.2H6z"
  })));
};
export default SvgIconClockSmall;